import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

/**
 * Wraps RAMS routes and redirects to tenant dashboard when RAMS is disabled
 * for the tenant. Global admins bypass the check. Use inside ProtectedRoute
 * with tenant roles so the user is already authenticated.
 */
export default function RamsRouteGuard({ children }) {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'global_admin') {
    return children;
  }

  if (!user.ramsEnabled) {
    return <Navigate to="/tenant/dashboard" replace />;
  }

  return children;
}
